import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, timeout } from 'rxjs';

import { UMP_HOST, UMP_REQUEST_TIMEOUT_MS } from '../../utils/constants';

import { SystemUpgrade } from './interfaces';

@Injectable({
  providedIn: 'root',
})
export class UmpService {
  private readonly endpoints = {
    status: '/api/v1/status',
  };

  constructor(private httpClient: HttpClient) {}

  isConfigured(): boolean {
    return !!UMP_HOST?.trim();
  }

  getUpgradeStatus(): Observable<SystemUpgrade> {
    return this.httpClient
      .get<SystemUpgrade>(`${UMP_HOST}${this.endpoints.status}`)
      .pipe(timeout(Number(UMP_REQUEST_TIMEOUT_MS)));
  }
}
